<template>
  <base-block
    class="recipe-saved-collection-card"
    size="third"
    type="recipeSavedCollection"
    :layout-type="layoutType"
    :url="url"
    is-link-card
    :small-card-type="smallCardType"
    :label-text="`receptsamling ${title} innehåller ${recipeCount} recept`"
  >
    <template #media>
      <menu-button
        v-if="$slots.menu"
        v-slot="scope"
        :aria-label="`receptsamling ${title}`"
      >
        <slot
          name="menu"
          @click="scope.toggle()"
        />
      </menu-button>
      <image-grid
        v-edit="'RecipeId'"
        :image-urls="images"
        :scroll-container-id="scrollContainerId"
        :dimensions="dimensions"
      />
    </template>
    <template #content>
      <h3
        v-edit="'Title'"
        aria-label="Receptsamling"
        class="recipe-saved-collection-card__content__title"
      >
        {{ title }}
      </h3>
      <div class="recipe-saved-collection-card__content__recipe-count">
        {{ recipeCount }} recept
      </div>
    </template>
  </base-block>
</template>

<script>
import BaseBlock, { layoutTypes } from "./BaseBlockComponent"
import ImageGrid from "./ImageGrid"
import MenuButton from "./MenuButton"

const FALLBACK_IMAGE = 'Receptsidan/Placeholder_Recipe_Collection_2x.jpg'

export default {
  name: "RecipeSavedCollectionLinkCard",
  components: {
    BaseBlock,
    ImageGrid,
    MenuButton
  },
  props: {
    url: {
      type: String,
      default: ""
    },
    imageUrls: {
      type: Array,
      default: () => null
    },
    recipeCount: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    fallbackImg: {
      type: String,
      default: FALLBACK_IMAGE
    },
    dimensions: {
      type: Object,
      default: () => ({
        small: {
          width: 220,
        },
        medium: {
          width: 320,
        },
        large: {
          width: 400,
        },
      })
    },
    smallCardType: {
      type: Boolean,
      default: false
    },
    scrollContainerId: {
      type: String,
      default: null
    },
    ssrAsSize: {
      type: String,
      default: ""
    },
  },
  data () {
    return {
      isMounted: false,
    }
  },
  computed: {
    images () {
      if(!this.imageUrls || this.imageUrls.length === 0) {
        return [this.fallbackImg]
      }
      return this.imageUrls
    },
    layoutType () {
      const size = (!this.isMounted && this.ssrAsSize) ? this.ssrAsSize : this.$root.currentSize
      switch (size) {
        case "sm":
        case "xs":
        case "xxs":
          return layoutTypes.mediaRightSecondary
        default:
          return layoutTypes.mediaTop
      }
    },
  },
  mounted () {
    this.isMounted = true
  },
}
</script>

<style lang="scss">
.recipe-saved-collection-card {
  $this: &;

  align-items: center;

  .button--recipeid-edit.button--editbutton {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
  }

  .base-block--media-left .image-grid-standard {
    margin-right: -0.5rem;
  }

  .base-block__content-slot {
    &__padding {
      margin: auto;

      #{$this}__content__recipe-count {
        @include font(text, 3, "normal");

        color: $color-inactive-text;
      }

      #{$this}__content__title {
        @include font(rubrik, 2, "normal");

        margin: 0;
        text-transform: none;
        -webkit-line-clamp: 2;
        overflow: hidden;
        max-height: 3.5rem;

        @include media-breakpoint-up(lg) {
          max-height: 4rem;
        }
      }

      #{$this}__content__button {
        margin-top: 2rem;

        @include media-breakpoint-up(lg) {
          margin-top: 2.5rem;
        }
      }
    }
  }

  $contentPadding: ".base-block__content-slot .base-block__content-slot__padding";

  @include media-breakpoint-up(md) {
    &.base-block.base-block--third #{$contentPadding} {
      padding: 1.25rem 1rem 2rem;
    }
  }

  @include media-breakpoint-down(sm) {
    &.base-block.base-block--highlight .base-block__inner-wrapper {
      min-height: 20rem;

      .base-block__media-lg {
        height: 20rem;
      }
    }
  }

  body:not([ie11]) &.base-block--media-top .base-block__media-lg {
    @include media-breakpoint-up(md) {
      flex: 0%; // Fix for safari
    }
  }

  .base-block--media,
  .base-block__media-lg {
    position: relative;
  }

  .menu-button {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    z-index: 1;
  }
}
</style>
